import {
  Checkbox,
  ClickAwayListener,
  Fade,
  MenuItem,
  MenuList,
  Popper,
  TableRow,
  TableSortLabel,
  Theme,
  Typography,
  withStyles
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles, WithStyles } from '@material-ui/core/styles';
import { ArrowDropDown } from '@material-ui/icons';
import React from 'react';
import { sort } from '../../models/states';
import {
  Actions,
  Customer,
  FeedName,
  HeadendStatus,
  LastPublishedPlaylistId,
  LatestPlaylistStatus,
  MissingAssetsOnCloud,
  PlaylistDate,
  PlaylistValidation,
  SrNo
} from './Columns';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      background: theme.tertiaryColors.grey,
      textTransform: 'uppercase',
      height: '2rem',
      whiteSpace: 'nowrap'
    },
    sortHeader: {
      cursor: 'pointer',
      fontSize: '0.8125rem'
    },
    filterHeader: {
      display: 'flex',
      alignItems: 'center'
    },
    filter: {
      display: 'flex',
      cursor: 'pointer',
      alignItems: 'center'
    },
    checkboxRoot: {
      '&$checked': theme.checkbox.yellow
    },
    checked: {},
    stickHeader: {
      position: 'sticky',
      top: '3rem',
      backgroundColor: theme.tertiaryColors.header,
      zIndex: 100
    }
  });

class PlaylistPodTableHeader extends React.Component<
  IPlaylistPodTableHeader,
  IPlaylistPodHeaderState
> {
  constructor(props: IPlaylistPodTableHeader) {
    super(props);
    this.state = {
      isOpenFilter: false,
      anchorEl: null
    };
  }
  handleOpenFilter = (e: React.MouseEvent<HTMLElement>, filterId: string) => {
    this.setState({ anchorEl: e.target });
    this.props.onToggleHeaderFilters(filterId);
  };
  createSortHandler = (
    event: React.MouseEvent<HTMLElement>,
    property: string
  ) => {
    this.props.onRequestSort(event, property);
  };
  handleCloseFilter = (filterId: string) => {
    this.setState({ isOpenFilter: false, anchorEl: null });
    this.props.onToggleHeaderFilters(filterId);
  };

  renderFilterHeader = (label: string, filterId: string): React.ReactNode => {
    const { classes, filters } = this.props;
    const filterList = filters[filterId];
    return (
      <div>
        <div className={classes.filterHeader}>
          <div
            onClick={e => this.handleOpenFilter(e, filterId)}
            className={classes.filter}
          >
            <Typography variant="caption">{label}</Typography>
            <ArrowDropDown />
          </div>
        </div>
        <Popper
          open={
            this.props.isOpenFilters[filterId]
              ? this.props.isOpenFilters[filterId]
              : false
          }
          style={{ zIndex: 1000 }}
          anchorEl={this.state.anchorEl}
          transition
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={100}>
              <ClickAwayListener
                onClickAway={() => this.handleCloseFilter(filterId)}
              >
                <Paper style={{ overflowY: 'scroll', maxHeight: '40vh' }}>
                  <MenuList>
                    {filterList.map(filter => {
                      return (
                        <MenuItem
                          key={filter.label}
                          style={{ textTransform: 'uppercase', paddingLeft: 0 }}
                          onClick={() =>
                            this.props.onToggleFilters(filterId, filter)
                          }
                        >
                          <Checkbox
                            checked={filter.isSet}
                            value="checkedB"
                            color="primary"
                            classes={{
                              root: classes.checkboxRoot,
                              checked: classes.checked
                            }}
                          />
                          <Typography variant="caption">
                            {filter.value}
                          </Typography>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </Paper>
              </ClickAwayListener>
            </Fade>
          )}
        </Popper>
      </div>
    );
  };

  renderSortHeader = (
    label: string,
    headerLabel: string,
    order: sort,
    orderBy: string
  ): React.ReactNode => {
    const { classes } = this.props;
    return (
      <TableSortLabel
        active={orderBy === headerLabel}
        direction={order}
        onClick={e => this.createSortHandler(e, headerLabel)}
        className={classes.sortHeader}
      >
        <Typography variant={'caption'}>{label}</Typography>
      </TableSortLabel>
    );
  };
  public render() {
    const { classes, order, orderBy } = this.props;
    return (
      <TableRow className={classes.root}>
        <SrNo className={classes.stickHeader}>
          {this.renderSortHeader('Sr No', 'sr_no', order, orderBy)}
        </SrNo>
        <Customer className={classes.stickHeader}>
          {this.renderFilterHeader('Customer', 'customer')}
        </Customer>
        <FeedName className={classes.stickHeader}>
          {this.renderFilterHeader('Feed Name', 'feed_name')}
        </FeedName>
        <PlaylistDate className={classes.stickHeader}>
          {/* <Typography variant={'caption'}>{'Playlist Date'}</Typography> */}

          {this.renderFilterHeader('Playlist Date', 'play_on')}
        </PlaylistDate>
        <LastPublishedPlaylistId className={classes.stickHeader}>
          <Typography variant={'caption'} className={classes.stickHeader}>
            Last Published Playlist Version
          </Typography>
        </LastPublishedPlaylistId>
        <MissingAssetsOnCloud className={classes.stickHeader}>
          <Typography variant={'caption'}>
            Missing Assets on Cloud/Headends
          </Typography>
        </MissingAssetsOnCloud>
        <HeadendStatus className={classes.stickHeader}>
          <Typography variant={'caption'}>Headend Status</Typography>
        </HeadendStatus>
        <LatestPlaylistStatus className={classes.stickHeader}>
          <Typography variant={'caption'}>Latest Playlist Version</Typography>
        </LatestPlaylistStatus>
        <PlaylistValidation className={classes.stickHeader}>
          {this.renderFilterHeader('Status', 'skynet_status')}
          <Typography variant={'caption'} />
        </PlaylistValidation>
        {globalThis.UI_CONFIG &&
        globalThis.UI_CONFIG.disable_issue_tracker ? null : (
          <Actions className={classes.stickHeader}>
            <Typography variant={'caption'}>
              {this.renderFilterHeader('Escalation Status', 'action')}
            </Typography>
          </Actions>
        )}
      </TableRow>
    );
  }
}
interface IPlaylistPodHeaderState {
  isOpenFilter: boolean;
  anchorEl: any;
}
interface IPlaylistTableHeaderOwnProps {
  order: sort;
  orderBy: string;
  onRequestSort: any;
  filters: any;
  onToggleFilters: any;
  isOpenFilters: any;
  onToggleHeaderFilters: any;
}
type IPlaylistPodTableHeader = IPlaylistTableHeaderOwnProps &
  WithStyles<typeof styles>;

export default withStyles(styles)(PlaylistPodTableHeader);
